import { createFileRoute, notFound, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useOrganization } from '@clerk/clerk-react';
import { DashboardPage } from '~/components/ui/dashboard/DashboardPage';
import { canAccess } from '~/utils/rbac';
import { useFeatureFlagsFromClerk } from '~/hooks/useOrganizationConfig';
import { isFeatureEnabled } from '~/config/organizationConfig';
import { FEATURE_FLAGS } from '~/config/orgConfigConstants';

export const Route = createFileRoute('/_authLayout/dashboard/$dashboardId')({
  beforeLoad: async () => {
    if (!canAccess('dashboard')) {
      throw notFound();
    }
  },
  component: DashboardRouteComponent,
});

function DashboardRouteComponent() {
  const { dashboardId } = Route.useParams();
  const navigate = useNavigate();
  const { isLoaded: isOrgLoaded } = useOrganization();
  const featureFlags = useFeatureFlagsFromClerk();
  const isDynamicDashboardEnabled = isFeatureEnabled(
    featureFlags,
    FEATURE_FLAGS.DYNAMIC_DASHBOARD,
  );

  useEffect(() => {
    if (isOrgLoaded && !isDynamicDashboardEnabled) {
      navigate({ to: '/' });
    }
  }, [isOrgLoaded, isDynamicDashboardEnabled, navigate]);

  if (!isOrgLoaded || !isDynamicDashboardEnabled) {
    return null;
  }

  return (
    <DashboardPage
      dashboardId={dashboardId}
      breadcrumbLabel="Dashboards"
      breadcrumbUrl="/dashboard"
      pageTaglinePrefix="Dashboard"
    />
  );
}
